// extracted by mini-css-extract-plugin
module.exports = {"introSlides":"IntroSlider_introSlides__2AwY8"};